import {
    USERS_READ_FROM_FORAGE,
    USERS_FORGET_USERS,
    USERS_LOGIN_USER,
    USERS_LOGOUT_USER,
    USERS_CHANGED,
    USER_ADDED,
    USERS_ADDED,
} from './constants'

// Update the list of users from the forage
export function setUsers(users) {
    return {
        type: USERS_READ_FROM_FORAGE,
        payload: users,
    }
}

export function resetUsers() {
    return {
        type: USERS_FORGET_USERS,
    }
}

export function logIn(serverId, user) {
    return {
        type: USERS_LOGIN_USER,
        payload: {
            serverId,
            user,
        },
    }
}

export function logOut(serverId, userId) {
    return {
        type: USERS_LOGOUT_USER,
        payload: {
            serverId,
            userId,
        },
    }
}

export function usersChanged(users) {
    return {
        type: USERS_CHANGED,
        payload: users,
    }
}

export function userAdded(serverId, userId) {
    return {
        type: USER_ADDED,
        payload: { serverId, userId },
    }
}

export function usersAdded(userList) {
    return {
        type: USERS_ADDED,
        payload: userList,
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/actions.js